import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { Field, reduxForm } from 'redux-form';
import CustomerValidate from '../registration-validation';
import { useTranslation } from 'react-i18next';
import TakeoutBottomFunction from '../../../basic/takeout-bottom-function';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  formFiledContainer: {
    '& .MuiBox-root': {
      height: '20vh',
      overFlowY: 'auto'
    }
  }
}));

const renderField = ({
  handleClickShowPassword,
  input,
  label,
  isPassword,
  meta: { touched, invalid, error },
  ...custom
}) => {
  const opt = {};
  (input.name === 'password' ||
    'currentPassword' ||
    'newPassword' ||
    'confirmPassword') &&
    (opt.endAdornment = (
      <InputAdornment position='end'>
        <IconButton
          aria-label='toggle password visibility'
          onClick={handleClickShowPassword}
          // onMouseDown={handleMouseDownPassword}
          edge='end'
        >
          {isPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    ));

  return (
    <TextField
      variant='outlined'
      margin='normal'
      fullWidth
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      autoComplete={label}
      InputProps={opt}
      {...input}
      {...custom}
    />
  );
};

const ChangePasswordForm = props => {
  const { handleSubmit, touchedOnLoad, history } = props;
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const handleClickShowPassword = password => {
    if (password === 'currentPassword') {
      setShowOldPassword(!showOldPassword);
    }
    if (password === 'newPassword') {
      setShowNewPassword(!showNewPassword);
    }
    if (password === 'confirmPassword') {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box pl={2} pr={2} mt={10} className={classes.formFiledContainer}>
        <Field
          name='currentPassword'
          isPassword={showOldPassword}
          component={renderField}
          label={t('Old Password')}
          type={showOldPassword ? 'text' : 'password'}
          handleClickShowPassword={() =>
            handleClickShowPassword('currentPassword')
          }
        />

        <Field
          name='newPassword'
          isPassword={showNewPassword}
          component={renderField}
          label={t('New Password')}
          type={showNewPassword ? 'text' : 'password'}
          handleClickShowPassword={() =>
            handleClickShowPassword('newPassword')
          }
        />
        <Field
          name='confirmPassword'
          isPassword={showConfirmPassword}
          component={renderField}
          label={t('Confirm Password')}
          type={showConfirmPassword ? 'text' : 'password'}
          handleClickShowPassword={() =>
            handleClickShowPassword('confirmPassword')
          }
        />
      </Box>

      <Grid container direction='column'>
        <TakeoutBottomFunction
          history={history}
          rightChildText={t('Update')}
        ></TakeoutBottomFunction>
      </Grid>
    </form>
  );
};

export default reduxForm({
  form: 'ChangePasswordForm', //                 <------ same form name
  //destroyOnUnmount: false, //        <------ preserve form data
  //forceUnregisterOnUnmount: true // <------ unregister fields on unmount
  validate: CustomerValidate
})(ChangePasswordForm);
